@import '../../../globals/main.scss';

:host {
  display: inline-flex;
}

:host > pn-button {
  margin-left: 0.35em;
  button {
    // justify-content: flex-start;

    .pn-button-bg {
      transition:
        width 0.2s cubic-bezier(0.7, 0, 0.3, 1) 0.2s,
        background 0.1s,
        box-shadow 0.1s,
        left 0.2s,
        transform 0.2s;
    }
  }

  &[data-loading='true'] {
    .pn-button-bg {
      left: 0;
      transform: translateX(0);
      transition:
        width 0.2s cubic-bezier(0.7, 0, 0.3, 1) 0.2s,
        background 0.1s,
        box-shadow 0.1s;
    }

    pn-spinner {
      left: 0.75em;
    }
  }
}

:host input {
  padding: 0.75em;
  min-height: 3em;
  font-size: 1em;
  height: 100%;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  outline: none;
  border-radius: 3em;
  border: 0.1rem solid $gray700;
  transition:
    box-shadow 0.15s,
    border 0.15s;
  color: $black;
  width: 100%;

  &::-webkit-search-cancel-button {
    display: none;
  }

  &::placeholder {
    color: $gray400;
    font-weight: normal;
  }

  &:focus {
    border: 0.1rem solid $blue700;
    box-shadow:
      0 0 0 0.2rem #fff,
      0 0 0 0.4rem $blue700;
  }

  &:hover {
    border: 0.1rem solid $blue400;
  }

  &:disabled {
    background: $gray50;
    border: none;
  }
}

:host > .input-container {
  width: 100%;
  position: relative;

  .button-container {
    :host[list] & {
      display: none;
    }
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    width: 3em;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(100%, -50%);
    background: $white;
    border: none;
    color: $blue700;
    padding: 0.3rem;
    margin: 0;
    font-size: 0.875em;
    border-radius: 50%;
    outline: none;
    transition:
      border 0.1s,
      background 0.2s,
      box-shadow 0.1s,
      transform cubic-bezier(0.7, 0, 0.3, 1) 0.2s,
      opacity 0.2s;
    border: 0.1rem solid transparent;
    -webkit-tap-highlight-color: transparent;

    &.clear,
    &.search {
      cursor: pointer;
    }

    &:focus {
      box-shadow:
        0 0 0 0.2rem #fff,
        0 0 0 0.4rem $blue700;
    }

    &:hover,
    &:focus {
      background: $blue50;
    }

    &:active {
      background: $blue700;

      pn-icon svg,
      pn-icon svg path {
        fill: white;
      }
    }
  }
}

:host .searching {
  button.search {
    transform: translate(150%, -50%);
  }

  button.clear {
    transform: translate(-50%, -50%);
  }
}

/*---------------------------------------Button Variants-------------------------------------------*/
:host .button-none,
:host .button-icon-inline {
  input {
    padding-right: 3.3em;
  }

  pn-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(100%, -50%);
    transition: transform cubic-bezier(0.7, 0, 0.3, 1) 0.2s;
  }

  button.search {
    transform: translate(-50%, -50%);
  }

  &.loading {
    button {
      transform: translate(100%, -50%);
    }

    pn-spinner {
      transform: translate(-50%, -50%);
    }
  }
}

:host .button-none.searching button.search {
  transform: translate(100%, -50%);
}

:host .button-icon > pn-button {
  &[data-loading='true'] {
    .pn-button-bg {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
/*---------------------------------------/Button Variants-------------------------------------------*/
